// deps
import React, { memo, useMemo } from "react";

// internal-deps
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";
import { AUTOPAY_PAYMENT_FAILURE_SCREEN_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { isToingFlow } from "@swiggy-private/checkout-core";

// defs
import { PaymentFailureResponse } from "@swiggy-private/payment-types";

// constants
import { TEXTS } from "@payment-client/components/autopay-payment-failure-screen/constants";

// styles
import styles from "../styles.scss";

export interface Props {
    handlePrimaryCtaClick: VoidFunction;
    handleSecondaryCtaClick: VoidFunction;
    cta?: PaymentFailureResponse["autopayCta"];
}

function ConsentVariantButtons(props: Props) {
    const { primary, secondary } = props?.cta || {};
    const isToingApp = useMemo(() => isToingFlow(), []);

    return (
        <>
            <SuperButton
                onClick={props.handlePrimaryCtaClick}
                ariaLabel={TEXTS.PLACE_ORDER}
                data-testid={AUTOPAY_PAYMENT_FAILURE_SCREEN_TEST_IDS.CONSENT_PRIMARY_CTA}
                buttonType="specialPositive"
                buttonSize="large"
            >
                {primary || TEXTS.PLACE_ORDER}
            </SuperButton>

            <TextButton
                className={styles.secondaryCta}
                buttonSize="medium"
                color={isToingApp ? "special_button_text" : "text_High_Emphasis"}
                onClick={props.handleSecondaryCtaClick}
                data-testid={AUTOPAY_PAYMENT_FAILURE_SCREEN_TEST_IDS.CONSENT_SECONDARY_CTA}
            >
                {secondary || TEXTS.DONT_PLACE_MY_ORDER}
            </TextButton>
        </>
    );
}

export default memo(ConsentVariantButtons);
